/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    permissions: 'view-staff',
  },
  {
    url: '/pages/reporting',
    name: 'Reporting',
    slug: 'report',
    icon: 'BarChartIcon',
    i18n: 'Reporting',
    permissions: 'view-staff',
  },
  // {
  //   url: '',
  //   name: 'Inventory',
  //   slug: 'home',
  //   icon: 'EyeIcon'
  // },
  // {
  //   url: '',
  //   name: 'Formulations & NPD',
  //   slug: 'home',
  //   icon: 'HomeIcon'
  // },
  // {
  //   url: '',
  //   name: 'Sales & Marketing',
  //   slug: 'home',
  //   icon: 'HomeIcon'
  // },
  {
    header: 'Operations',
    icon: 'ArchiveIcon',
    items: [
      // {
      //   name: 'Inventory',
      //   slug: 'home',
      //   icon: 'ListIcon'
      // },
      {
        name: 'Formulations & NPD',
        slug: 'manage-formulation',
        icon: 'ShareIcon',
        group_permissions: 'view-formulations,view-project-brief,view-sample-order,create-edit-sample-order,create-edit-project-brief,create-formulations,view-partial-formulation-details',
        submenu: [
          {
            url: '/pages/formulations',
            name: 'Product Formulations',
            slug: 'manage-formulation',
            icon: 'ShareIcon',
            permissions: 'view-formulations,create-formulations,view-partial-formulation-details',
          },
          {
            url: '/pages/project-brief',
            name: 'Project briefs',
            slug: 'manage-project-brief',
            icon: 'BriefcaseIcon',
            permissions: 'view-project-brief,create-edit-project-brief',
          },
          {
            url: '/pages/sample-orders',
            slug: 'manage-sample-orders',
            name: 'Samples',
            icon: 'BriefcaseIcon',
            permissions: 'view-sample-order,create-edit-sample-order',
          }
        ]
      },
      {
        name: 'Inventory',
        slug: 'manage-raw-materials',
        icon: 'BoxIcon',
        group_permissions: 'view-supplier-raw-materials,create-edit-supplier-raw-materials,view-raw-material-orders,create-edit-raw-material-orders,' +
          'view-raw-material-use-report,view-sundry-orders,create-edit-sundry-orders,view-sundry-items-use-report,view-sundry-supplier-items,' +
          'create-sundry-supplier-items,view-other-suppliers,create-edit-other-suppliers,view-other-orders,' +
          'create-edit-other-orders,view-raw-material-stock-inventory,view-product-stock-inventory,view-sundry-item-stock-inventory,' +
          'view-raw-material-waste-inventory,view-product-waste-inventory',
        submenu: [
          {
            url: '/pages/raw-materials',
            name: 'PO Raw Materials',
            slug: 'manage-raw-materials',
            icon: 'BoxIcon',
            permissions: 'view-supplier-raw-materials,create-edit-supplier-raw-materials,view-raw-material-orders,create-edit-raw-material-orders,' +
              'view-raw-material-use-report',
          },
          {
            url: '/pages/sundry-items',
            name: 'PO Manufacturing Sunderies',
            slug: 'manage-sundry-items',
            icon: 'BoxIcon',
            permissions: 'view-sundry-orders,create-edit-sundry-orders,view-sundry-items-use-report,view-sundry-supplier-items,' +
              'create-sundry-supplier-items',
          },
          {
            url: '/pages/other-supplier-service',
            name: 'PO Other Items & services',
            slug: 'other-service',
            icon: 'SettingsIcon',
            permissions: 'view-other-suppliers,create-edit-other-suppliers,view-other-orders,' +
              'create-edit-other-orders',
          },
          {
            url: '/pages/stock-check',
            name: 'Stock & Waste Management',
            slug: 'stock-check',
            icon: 'SettingsIcon',
            permissions: 'view-raw-material-stock-inventory,view-product-stock-inventory,view-sundry-item-stock-inventory,' +
              'view-raw-material-waste-inventory,view-product-waste-inventory,view-return-product-inventory',
          },
          {
            url: '/pages/stock-report',
            name: 'SSL Stock Report',
            slug: 'stock-check',
            icon: 'SettingsIcon',
            permissions: 'view-raw-material-stock-inventory,view-product-stock-inventory,view-sundry-item-stock-inventory,' +
              'view-raw-material-waste-inventory,view-product-waste-inventory,view-return-product-inventory',
          },
        ]
      },
      {
        name: 'QC',
        slug: 'manage-wc',
        icon: 'EyeIcon',
        group_permissions: 'view-traceability-report,view-raw-material-mass-balance-report,view-sundry-mass-balance-report',
        submenu: [
          {
            url: '/pages/traceability-audit',
            name: 'Traceability Audit',
            slug: 'traceability-audit',
            icon: 'SettingsIcon',
            permissions: 'view-traceability-report',
          },
          {
            url: '/pages/mass-balance-audit',
            name: 'RM Mass Balance',
            slug: 'mass-balance-audit',
            icon: 'SettingsIcon',
            permissions: 'view-raw-material-mass-balance-report',
          },
          {
            url: '/pages/sundry-mass-balance-audit',
            name: 'Sundry Mass Balance',
            slug: 'sundry-mass-balance-audit',
            icon: 'SettingsIcon',
            permissions: 'view-sundry-mass-balance-report',
          },
          {
            url: '/pages/supplier-accreditation-report',
            name: 'Supplier Accreditation Report',
            slug: 'supplier-accreditation-report',
            icon: 'SettingsIcon',
            permissions: '',
          },
          {
            url: '/pages/taste-Panels',
            name: 'Taste Panel',
            slug: 'taste-Panel',
            icon: 'SettingsIcon',
            permissions: 'view-quality-control-tastings,create-edit-quality-control-tastings',
          },
          {
            url: '/pages/triangle-tests',
            name: 'Triangle Tests',
            slug: 'triangle-tests',
            icon: 'SettingsIcon',
            permissions: '',
          },
        ],
      },
      {
        name: 'Sales & Marketing',
        slug: 'manage-raw-materials',
        icon: 'DollarSignIcon',
        group_permissions: 'view-order,create-edit-order,view-sales-quote,create-edit-sales-quote,' +
          'view-forecast-tool,create-edit-forecast-tool,view-credit-note,view-otif-missed-data',
        submenu: [
          {
            url: '/pages/product-orders',
            name: 'Sales Orders',
            slug: 'manage-product-orders',
            icon: 'BoxIcon',
            permissions: 'view-order,create-edit-order',
          },
          {
            url: '/pages/invoices',
            name: 'SO Invoices',
            slug: 'manage-invoices',
            icon: 'BoxIcon',
            permissions: 'view-invoice',
          },
          {
            url: '/pages/sales-quote',
            name: 'Sales Quote',
            slug: 'manage-sales-quote',
            icon: 'BoxIcon',
            permissions: 'view-sales-quote,create-edit-sales-quote',
          },
          {
            url: '/pages/forecasts',
            name: 'Forecast Tool',
            slug: 'forecast-tool',
            icon: 'BoxIcon',
            permissions: 'view-forecast-tool,create-edit-forecast-tool',
          },
          {
            url: '/pages/outstanding-orders',
            name: 'Outstanding Orders',
            slug: 'outstanding-orders',
            icon: 'BoxIcon',
            permissions: 'view-order',
          },
          {
            url: '/pages/otif-report',
            name: 'OTIF Report',
            slug: 'otif-report',
            icon: 'BoxIcon',
            permissions: 'view-otif-missed-data',
          },
          {
            url: '/pages/credit-notes',
            name: 'Credit Notes',
            slug: 'credit-notes',
            icon: 'BoxIcon',
            permissions: 'view-credit-note',
          }
        ]
      },
      {
        name: 'Manufacturing',
        icon: 'CpuIcon',
        group_permissions: 'view-production-lines,create-edit-production-lines,view-work-orders,create-edit-work-orders',
        submenu: [
          {
            url: '/pages/manufacturing/production-line',
            name: 'Production Lines',
            slug: 'production-line',
            icon: 'BoxIcon',
            permissions: 'view-production-lines,create-edit-production-lines',
          },
          {
            url: '/pages/manufacturing/work-orders',
            name: 'Work Orders',
            slug: 'work-orders',
            icon: 'BoxIcon',
            permissions: 'view-work-orders,create-edit-work-orders',
          },
          {
            url: '/pages/manufacturing/manufacturing-timeline',
            name: 'Manufacturing Plan',
            slug: 'manufacturing-timeline',
            icon: 'BoxIcon',
            permissions: 'view-work-orders',
          }
        ]
      },
      {
        name: 'Financial Management',
        icon: 'LayersIcon',
        group_permissions: 'view-grni-report,view-invoice',
        submenu: [
          {
            url: '/pages/so-invoices',
            name: 'SO Invoices',
            slug: 'manage-invoices',
            icon: 'BoxIcon',
            permissions: 'view-invoice',
          },
          {
            url: '/pages/po-invoices',
            name: 'PO Invoices',
            slug: 'grni-report',
            icon: 'SettingsIcon',
            permissions: 'view-grni-report',
          },
          {
            url: '/pages/credit-limit-requests',
            name: 'Customer Credit Report',
            slug: 'credit-limit-report',
            icon: 'SettingsIcon',
            permissions: 'view-grni-report',
          },
        ],
      },
      {
        url: '/pages/courier-shipments',
        name: 'Goods out & Logistic',
        slug: 'courier-shipments',
        icon: 'ArchiveIcon',
        permissions: 'view-goods-out-logistics,create-edit-goods-out-logistics',
      },
      {
        name: 'CRM',
        slug: 'manage-raw-materials',
        icon: 'MailIcon',
        group_permissions: 'end-user,end-user,end-user,view-indirect-channel-partners,'+
          'create-edit-indirect-channel-partners,account-owner-summary',
        submenu: [
          {
            url: '/pages/crm/account-owner-summary',
            name: 'CRM Summary',
            slug: 'account-owner-summary',
            permissions: 'end-user,executive-admin',
          },
          {
            url: '/pages/crm/marketing-leads',
            slug: 'marketing-leads',
            name: 'New Enquiries',
            permissions: 'end-user,executive-admin',
          },
          {
            url: '/pages/crm/marketing-leads-suspect',
            name: 'Leads',
            slug: 'marketing-leads-suspect',
            permissions: 'end-user,executive-admin',
          },
          {
            url: '/pages/crm/marketing-leads-opportunities',
            name: 'Opportunities',
            slug: 'marketing-leads-opportunities',
            permissions: 'end-user,executive-admin',
          },
          {
            url: '/pages/crm/marketing-leads-influence',
            name: 'Subscribers',
            slug: 'marketing-leads-influence',
            permissions: 'aggregated-view-subscribers-and-settings',
          },
          {
            url: '/pages/crm/marketing-leads-closed',
            name: 'Closed',
            slug: 'marketing-leads-closed',
            permissions: 'end-user,executive-admin',
          },
          {
            url: '/pages/crm/merged-fields',
            name: 'CRM Fields',
            slug: 'merged-fields',
            permissions: 'aggregated-view-subscribers-and-settings',
          },
          {
            url: '/pages/crm/marketing-leads-indirect-channel',
            name: 'Indirect Channel',
            slug: 'marketing-leads-indirect-channel',
            permissions: 'view-indirect-channel-partners,create-indirect-channel-partnerss',
          },
          {
            url: '/pages/crm/aggregated-activity',
            name: 'Aggregated Activity',
            slug: 'aggregated-activity',
            permissions: 'aggregated-view-subscribers-and-settings',
          }
        ],
      },
       {
        name: 'Scheduled Tasks',
        slug: 'scheduled-tasks',
        icon: 'MailIcon', 
        group_permissions:'view-scheduled-tasks',
        submenu: [
          {
            url: '/pages/scheduled-tasks',
            name: 'Task Scheduling Manager',
            slug: 'scheduled-tasks',
            permissions: 'view-scheduled-tasks',
          },
          {
            url: '/pages/task-instance',
            name: 'Active Tasks',
            slug: 'task-instance',
            permissions: 'view-scheduled-tasks',
          },
          {
            url: '/pages/archived-tasks',
            name: 'Archived Tasks',
            slug: 'archived-tasks',
            permissions: 'view-scheduled-tasks',
          },
        ]
      },
      // {
      //   url: '/pages/project-brief',
      //   name: 'Project Brief',
      //   slug: 'manage-project-brief',
      //   icon: 'BriefcaseIcon'
      // },
      // {
      //   name: 'Quality Assurance',
      //   slug: 'home',
      //   icon: 'SquareIcon'
      // }
    ]
  },
  // {
  //   header: 'Sales & Marketing',
  //   icon: 'ArchiveIcon',
  //   items: [
  //     {
  //       name: 'Reporting',
  //       slug: 'home',
  //       icon: 'PaperclipIcon'
  //     },
  //     {
  //       name: 'Budgeting',
  //       slug: 'home',
  //       icon: 'BriefcaseIcon'
  //     },
  //     {
  //       name: 'HR & People',
  //       slug: 'home',
  //       icon: 'UserXIcon'
  //     }
  //   ]
  // },
  {
    header: 'User Settings',
    icon: 'ArchiveIcon',
    items: [
      {
        name: 'Manage Nimble',
        slug: 'page2',
        icon: 'UsersIcon',
        group_permissions: 'view-staff,create-edit-staff,view-staff-role,create-edit-staff-role,view-staff-departments,create-edit-staff-departments,' +
          'view-customer,create-edit-customer,view-supplier,view-sundry-suppliers,view-other-suppliers,view-courier-suppliers,' +
          'view-budget-tool,create-edit-budget-tool,sales-crm-access,view-staff-leaves',
        submenu: [
          {
            url: '/pages/manage-nimble/users',
            name: 'Staff',
            slug: 'page2',
            icon: 'UsersIcon',
            permissions: 'view-staff,create-edit-staff,view-staff-role,create-edit-staff-role,view-staff-departments,create-edit-staff-departments,view-staff-leaves,create-staff-leaves,edit-staff-leaves',
          },
          {
            url: '/pages/manage-nimble/customers',
            name: 'Customers',
            slug: 'manage-customers',
            icon: 'UsersIcon',
            permissions: 'view-customer,create-edit-customer,sales-crm-access',
          },
          {
            url: '/pages/manage-nimble/suppliers',
            name: 'Suppliers',
            slug: 'manage-suppliers',
            icon: 'UsersIcon',
            permissions: 'view-supplier,view-sundry-suppliers,view-other-suppliers,view-courier-suppliers',
          },
          {
            url: '/pages/budget-tool',
            name: 'Budget Tool',
            slug: 'budget-tool',
            icon: 'BoxIcon',
            permissions: 'view-budget-tool,create-edit-budget-tool',
          }
          // {
          //   url: '/pages/edit-parameters',
          //   name: 'Edit Parameters',
          //   slug: 'edit-parameters',
          //   icon: 'UsersIcon',
          //   permissions: 'view-staff',
          // }
        ]
      }
    ]
  },
  {
    header: 'Settings',
    icon: 'ArchiveIcon',
    group_permissions: 'view-raw-material-stock-adjust-log,view-product-stock-adjust-log,view-sundry-item-stock-adjust-log,' +
      'view-company-details-setting,view-incoterms-setting,view-holidays-setting,view-currency-setting,' +
      'view-carriers-setting,view-tax-codes-setting,view-production-codes-setting,view-ccp-items-setting,' +
      'view-raw-material-codes-setting,view-manage-notifications-setting,view-manage-reports-setting,view-bank-account-setting,' +
      'view-raw-material-qc-test-setting',
    items: [
      {
        url: '/pages/activity-logs',
        name: 'Activity Log',
        slug: 'activity-logs',
        icon: 'ListIcon',
        permissions: 'view-raw-material-stock-adjust-log,view-product-stock-adjust-log,view-sundry-item-stock-adjust-log',
      },
      {
        url: '/pages/settings',
        name: 'System Settings',
        slug: 'settings',
        icon: 'SettingsIcon',
        permissions: 'view-company-details-setting,view-incoterms-setting,view-holidays-setting,view-currency-setting,' +
          'view-carriers-setting,view-tax-codes-setting,view-production-codes-setting,view-ccp-items-setting,' +
          'view-raw-material-codes-setting,view-manage-notifications-setting,view-manage-reports-setting,view-bank-account-setting,' +
          'view-raw-material-qc-test-setting',
      },
      {
        url: '/pages/my-schedule',
        name: 'Schedule',
        slug: 'my-schedule',
        icon: 'CalendarIcon',
        permissions: '',
      }
    ]
  }
  // {
  //   url: '/pages/patients',
  //   name: 'Patients',
  //   slug: 'page2',
  //   icon: 'UsersIcon'
  // },
  // {
  //   header: 'Settings',
  //   icon: 'UsersIcon',
  //   items: [
  //     {
  //       url: '/pages/users',
  //       name: 'Users',
  //       slug: 'page2',
  //       icon: 'UsersIcon'
  //       // submenu: [
  //       //   {
  //       //     url: '/pages/users',
  //       //     name: 'Prescribes',
  //       //     slug: 'page2',
  //       //     icon: 'FileIcon',
  //       //   },
  //       //   {
  //       //     url: '/pages/pending',
  //       //     name: 'Pending Prescribes',
  //       //     slug: 'page2',
  //       //     icon: 'FileIcon',
  //       //   }
  //       // ]
  //     },
  //     {
  //       url: '/pages/clinics',
  //       name: 'Clinics',
  //       slug: 'page2',
  //       icon: 'HomeIcon'
  //     }
  //   ]
  // }

]
